module.exports = __webpack_public_path__ + "img/45_22.89f9af60.png";